import React from 'react';
import { Button, Form, Input } from 'reactstrap';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';

class Contact extends React.Component {
    render(){
        return(
            <div>
                <br></br>
                <div className="containerForm">
                    <h1 className="H1" align="left"> Contact Us</h1> 
                    <p className="Font" align="left"> We would love to consult with you about your technology needs. Contact us to today
                        and find out how our team of custom software development and IT staffing services
                        can benefit your business.</p>
                </div>

                <div className="p-3">
                    <Breadcrumb tag="nav" listTag="div">
                        <BreadcrumbItem tag="a" href="/">Home</BreadcrumbItem>
                        <BreadcrumbItem active tag="span">Contact Us</BreadcrumbItem>
                    </Breadcrumb>
                </div>

                <div className="containerForm">
                    <h5 className="H5" align="left">Fill the box below:</h5>
                    <Form className="clearfix contactForm">
                        <Input className="form-control" 
                            type="text" placeholder="Your name"  required/>
                        <br />
                        <Input className="form-control" 
                            type="text" placeholder="Email" required/>
                        <br />
                        <Input className="form-control" 
                            type="text" placeholder="Phone" required/>
                        <br />
                        <Input type="textarea" className="form-control" 
                            rows="3" placeholder="Message" required/>
                        <br />
                        <Button color="primary" className="mb-3" size="lg" block>Submit</Button>
                    </Form> 
                </div>
            </div>
        )
    }
}

export default Contact;